// extracted by mini-css-extract-plugin
export default {"textarea":"p9YCPZ1","label":"ZhH612U"};